/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {ExternalLink} from "@eto/eto-ui-components";
import image1 from "./images/donate/image1.gif";
import {Alert, SubscribeBox} from "@eto/eto-ui-components";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    h1: "h1",
    span: "span",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Thank you for your interest in supporting ETO’s work!"), "\n", React.createElement(_components.p, null, "ETO is part of the Center for Security and Emerging Technology at Georgetown University. The easiest way to donate to ETO is through Georgetown's donor portal."), "\n", React.createElement(Alert, {
    className: "alert",
    color: "yellow-lighter",
    textIcon: "👉"
  }, React.createElement(_components.p, null, React.createElement(ExternalLink, {
    href: "https://giving.georgetown.edu/gu-gift"
  }, "Launch Georgetown's donor portal here"), ".")), "\n", React.createElement(_components.p, null, "On the first page of the donor portal's payment process, make sure to add your gift under \"Other,\" designating \"CSET Emerging Technology Observatory\" as the recipient."), "\n", React.createElement("figure", null, React.createElement("img", {
    src: image1,
    alt: "An animated screenshot from a web browser. The user scrolls down to the 'Other' dialog and inputs a dollar amount and a designation for 'CSET Emerging Technology Observatory.'"
  })), "\n", React.createElement(_components.p, null, "Once your donation is complete, please let us know you've contributed by emailing ", React.createElement(_components.a, {
    href: "cset@georgetown.edu"
  }, "cset@georgetown.edu"), ". You can also contact us there if you run into any issues while donating."), "\n", React.createElement(_components.h1, {
    id: "other-ways-to-give",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#other-ways-to-give",
    "aria-label": "other ways to give permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Other ways to give"), "\n", React.createElement(_components.h2, {
    id: "mutual-funds-or-stocks",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#mutual-funds-or-stocks",
    "aria-label": "mutual funds or stocks permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Mutual funds or stocks"), "\n", React.createElement(_components.p, null, "If you would like to donate mutual funds or stocks, please email us at ", React.createElement(_components.a, {
    href: "cset@georgetown.edu"
  }, "cset@georgetown.edu"), " so we can assist with the transfer process."), "\n", React.createElement(_components.h2, {
    id: "from-abroad-outside-the-united-states",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#from-abroad-outside-the-united-states",
    "aria-label": "from abroad outside the united states permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "From abroad (outside the United States)"), "\n", React.createElement(_components.p, null, "If you live outside of the U.S., please email us at ", React.createElement(_components.a, {
    href: "cset@georgetown.edu"
  }, "cset@georgetown.edu"), " so we can assist."), "\n", React.createElement(_components.h1, {
    id: "donor-resources",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#donor-resources",
    "aria-label": "donor resources permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Donor resources"), "\n", React.createElement(_components.p, null, "ETO is part of the Center for Security and Emerging Technology. To learn more about CSET’s research, funding policy and prior donors, visit the ", React.createElement(ExternalLink, {
    href: "https://cset.georgetown.edu/donate/"
  }, "CSET donor page"), "."), "\n", React.createElement(Alert, {
    className: "alert",
    color: "yellow-lighter",
    textIcon: "🔔"
  }, React.createElement(_components.p, null, "To learn more about opportunities to support ETO, email Christa Bennett at ", React.createElement(_components.a, {
    href: "christa.bennett@georgetown.edu"
  }, "christa.bennett@georgetown.edu"), ".")), "\n", React.createElement(SubscribeBox));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
